function nswTherapyDogsForm() {
  const forField = document.querySelector('[name=who-for]');
  const attachmentField = document.querySelector(
    '[name=confirmation-attachment]',
  );
  const firstBulletField = document.querySelector(
    '[name=confirmation-first-bullet]',
  );
  const riskField = document.querySelector(
    '[name=confirmation-risk-assessment]',
  );
  const addressField = document.querySelector(
    '[name=confirmation-link-address]',
  );

  if (!forField) {
    return;
  }

  const isFacility = function () {
    return forField.value === 'Facility';
  };

  const updateEmailFields = function () {
    if (isFacility()) {
      attachmentField.value =
        'Please find attached an Information Booklet and a sample Risk Assessment.';
      firstBulletField.value =
        'To apply for a Therapy dog you must be over 21 years of age';
      riskField.value =
        'You do not need to provide Guide Dogs NSW/ACT with a risk assessment however we do encourage you to complete one so that all aspects of dog ownership may be considered.';
      addressField.value = 'https://forms.office.com/r/M18T8tnbme';
    } else {
      attachmentField.value = 'Please find attached an Information Booklet.';
      firstBulletField.value =
        'To apply for a Therapy dog you must be over 21 years of age or have a parent/guardian that you reside with apply on your behalf.';
      riskField.value = '';
      addressField.value = 'https://forms.office.com/r/Rzwk2mb3y8';
    }
  };

  forField.addEventListener('change', updateEmailFields);
}

export function init() {
  nswTherapyDogsForm();
}
